import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getRequestDetails } from "../../../actions/AuthorizationDetailsTab";
import RequestDetailsTab from "../components/RequestDetails";
import { RequestDetailsDispatchTypes } from "../../../models/DispatchTypes/AuthorizationDetailstab";

const mapStateToProps = ({
  requestDetailsState
}: ApplicationState) => ({
  requestDetailsState: requestDetailsState.response
});

type DispatchTypes = RequestDetailsDispatchTypes

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, DispatchTypes>
) => {
    return {
      getRequestDetails: (referralId: number) => {
        dispatch(getRequestDetails(referralId));
      },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDetailsTab);
